import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogClose } from '@angular/material/dialog';
import {faCheck, faXmark} from '@fortawesome/free-solid-svg-icons';
import {MatButton} from '@angular/material/button';

@Component({
  standalone: true,
  selector: 'app-error-dialog',
  imports: [
    MatDialogClose,
    MatButton
  ],
  templateUrl: './error-dialog.component.html',
  styleUrls: ['./error-dialog.component.scss'],
})
export class ErrorDialogComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public data: any) {}

  protected readonly faCheck = faCheck;
  protected readonly faXmark = faXmark;
}
